// extracted by mini-css-extract-plugin
export default {"title":"u4SjtN","list":"IFilk_","item":"tGk3MW","link":"jjPA1m"};